export const environment = {
  production: false,
  env: 'Desarrollo',
  HomeTitle: 'MIS Utilitarios - Development environment',
  ApiUrl: 'https://misutlapidev.clavisco.com/',
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
